var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.209,
    height: 62.117,
    viewBox: "0 0 73.209 62.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7245",
    "data-name": "Rectangle 7245",
    width: 73.209,
    height: 62.117,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68427",
    "data-name": "Group 68427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68426",
    "data-name": "Group 68426",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44534",
    "data-name": "Path 44534",
    d: "M33.879,35.144H13.3a3.185,3.185,0,0,1-3.184-3.185V14.728a13.475,13.475,0,0,1,26.949,0V31.959A3.185,3.185,0,0,1,33.879,35.144Z",
    transform: "translate(-1.348 -0.181)",
    fill: "#40413f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44535",
    "data-name": "Path 44535",
    d: "M38.86,14.713V31.944a3.186,3.186,0,0,1-3.185,3.186h-3.6a3.186,3.186,0,0,0,3.185-3.186V14.713A13.475,13.475,0,0,0,23.586,1.358a13.294,13.294,0,0,1,1.8-.12A13.475,13.475,0,0,1,38.86,14.713Z",
    transform: "translate(-3.144 -0.165)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7241",
    "data-name": "Rectangle 7241",
    width: 24.049,
    height: 9.325,
    transform: "translate(38.931 10.962)",
    fill: "#b95d4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44536",
    "data-name": "Path 44536",
    d: "M76.715,66.558H34.355L37.1,52.227a8.959,8.959,0,0,1,6.051-6.84L55.536,41.4l12.384,3.989a8.957,8.957,0,0,1,6.051,6.84Z",
    transform: "translate(-4.579 -5.518)",
    fill: "#ffce34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44537",
    "data-name": "Path 44537",
    d: "M81.319,66.993H77.088L74.123,51.515a9.677,9.677,0,0,0-5.23-6.86l3.629,1.169a8.957,8.957,0,0,1,6.051,6.841Z",
    transform: "translate(-9.183 -5.952)",
    fill: "#fcb619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44538",
    "data-name": "Path 44538",
    d: "M64.826,43.695a7.15,7.15,0,0,1-14.263,0l7.131-2.3Z",
    transform: "translate(-6.74 -5.518)",
    fill: "#d4877a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7242",
    "data-name": "Rectangle 7242",
    width: 7.933,
    height: 9.731,
    transform: "translate(46.989 29.688)",
    fill: "#d4877a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44539",
    "data-name": "Path 44539",
    d: "M62.148,34.254v6a10.581,10.581,0,0,1-7.933,0v-6Z",
    transform: "translate(-7.226 -4.566)",
    fill: "#c76f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44540",
    "data-name": "Path 44540",
    d: "M71.833,26.4a2.812,2.812,0,1,0,0-5.624H69.97V26.4Z",
    transform: "translate(-9.326 -2.77)",
    fill: "#c76f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44541",
    "data-name": "Path 44541",
    d: "M45.032,26.4a2.812,2.812,0,1,1,0-5.624h1.862V26.4Z",
    transform: "translate(-5.627 -2.77)",
    fill: "#c76f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44542",
    "data-name": "Path 44542",
    d: "M67.694,19.7v5.1a10.52,10.52,0,0,1-21.039,0V19.7l1.007-.793a1.709,1.709,0,0,0,.651-1.342V12.648H66.036v4.915a1.709,1.709,0,0,0,.651,1.342Z",
    transform: "translate(-6.219 -1.686)",
    fill: "#d4877a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7243",
    "data-name": "Rectangle 7243",
    width: 17.722,
    height: 4.486,
    transform: "translate(42.094 10.963)",
    fill: "#c76f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44543",
    "data-name": "Path 44543",
    d: "M38.7,26.409a2.81,2.81,0,0,0,0-5.619H36.841v5.619Z",
    transform: "translate(-4.911 -2.771)",
    fill: "#6c3328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44544",
    "data-name": "Path 44544",
    d: "M11.919,26.409a2.81,2.81,0,0,1,0-5.619h1.858v5.619Z",
    transform: "translate(-1.22 -2.771)",
    fill: "#6c3328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44545",
    "data-name": "Path 44545",
    d: "M43.583,66.549H1.236L3.982,52.227a8.948,8.948,0,0,1,6.048-6.837L22.41,41.4l12.38,3.989a8.955,8.955,0,0,1,6.048,6.837Z",
    transform: "translate(-0.165 -5.518)",
    fill: "#eee1dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44546",
    "data-name": "Path 44546",
    d: "M48.185,66.983h-4.23L40.991,51.508a9.671,9.671,0,0,0-5.231-6.859l3.627,1.172a8.952,8.952,0,0,1,6.05,6.838Z",
    transform: "translate(-4.766 -5.951)",
    fill: "#dfd2cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44547",
    "data-name": "Path 44547",
    d: "M31.7,43.694a7.148,7.148,0,0,1-14.258,0l7.13-2.3Z",
    transform: "translate(-2.325 -5.518)",
    fill: "#863f30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7244",
    "data-name": "Rectangle 7244",
    width: 7.93,
    height: 9.728,
    transform: "translate(18.281 29.692)",
    fill: "#863f30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44548",
    "data-name": "Path 44548",
    d: "M29.022,34.258v6a10.574,10.574,0,0,1-7.93,0v-6Z",
    transform: "translate(-2.811 -4.566)",
    fill: "#6c3328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44549",
    "data-name": "Path 44549",
    d: "M24.05,9.265A10.516,10.516,0,0,0,13.534,19.781v4.568a10.516,10.516,0,0,0,21.031,0V19.781A10.515,10.515,0,0,0,24.05,9.265",
    transform: "translate(-1.804 -1.235)",
    fill: "#863f30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44550",
    "data-name": "Path 44550",
    d: "M24.371,9.27v6.078a8.2,8.2,0,0,1-8.2,8.2H13.535V19.782A10.514,10.514,0,0,1,24.047,9.266h0c.107,0,.215,0,.322,0",
    transform: "translate(-1.804 -1.235)",
    fill: "#6c3328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44551",
    "data-name": "Path 44551",
    d: "M32.5,66.749l-1.829,1.829H17.544l-1.83-1.829a5.935,5.935,0,1,1,8.394-8.393A5.934,5.934,0,0,1,32.5,66.749",
    transform: "translate(-1.863 -7.547)",
    fill: "#ed2b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44552",
    "data-name": "Path 44552",
    d: "M34.432,66.75,32.6,68.578H29.078l1.83-1.829a5.936,5.936,0,0,0-2.442-9.859A5.935,5.935,0,0,1,34.43,66.75Z",
    transform: "translate(-3.794 -7.547)",
    fill: "#b22029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44553",
    "data-name": "Path 44553",
    d: "M23.567,6.974v5.065a8.2,8.2,0,0,1-8.2,8.2H11.213A3.709,3.709,0,0,1,7.5,16.531a3.66,3.66,0,0,1,.039-.543.716.716,0,0,1,.707-.612h3.319a12.171,12.171,0,0,1,12-8.4",
    transform: "translate(-1 -0.929)",
    fill: "#40413f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44554",
    "data-name": "Path 44554",
    d: "M44.918,9.893v1.564a1.63,1.63,0,0,0,1.629,1.629H65.8a4.511,4.511,0,0,0,4.511-4.511V4.493A1.425,1.425,0,0,0,68.557,3.1a24.163,24.163,0,0,1-7.091.382,66.23,66.23,0,0,0-10.82.084,6.358,6.358,0,0,0-5.727,6.327",
    transform: "translate(-5.987 -0.408)",
    fill: "#863f30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44555",
    "data-name": "Path 44555",
    d: "M68.149,59.74a2.115,2.115,0,0,0-2.991-2.991,2.116,2.116,0,0,0-2.992,2.991l2.7,2.7a.406.406,0,0,0,.574,0h0Z",
    transform: "translate(-8.207 -7.485)",
    fill: "#ed2b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44556",
    "data-name": "Path 44556",
    d: "M62.421,24.706a3.959,3.959,0,0,0,3.967-3.883,3.888,3.888,0,0,0-2.337-3.561V11.793a5.558,5.558,0,0,0,1.343-3.625V4.085a2.5,2.5,0,0,0-3.079-2.437A23.156,23.156,0,0,1,55.542,2a67.716,67.716,0,0,0-11,.087,7.406,7.406,0,0,0-6.692,7.395v7.777a3.886,3.886,0,0,0-1.07.694V14.546A14.53,14.53,0,0,0,34.65,6.958a1.073,1.073,0,1,0-1.83,1.121,12.377,12.377,0,0,1,1.824,6.467V17.04a4.526,4.526,0,0,0-.922-.1,11.629,11.629,0,0,0-10.082-9.9V6.76a1.073,1.073,0,0,0-2.145,0v4.35a7.137,7.137,0,0,1-7.129,7.129H10.213A2.638,2.638,0,0,1,7.573,15.6c0-.027,0-.055,0-.082h3a1.073,1.073,0,0,0,0-2.145H9.9A12.4,12.4,0,0,1,29.687,4.629a1.072,1.072,0,0,0,1.289-1.714A14.547,14.547,0,0,0,7.742,13.379H7.25a1.8,1.8,0,0,0-1.768,1.527,4.783,4.783,0,0,0,1.662,4.364,3.9,3.9,0,0,0,.55,4.03V31.78a4.263,4.263,0,0,0,4.257,4.257h5.255v.339L9.536,38.85a10.02,10.02,0,0,0-6.772,7.657L.02,60.83a1.072,1.072,0,1,0,2.106.4L4.874,46.907A7.878,7.878,0,0,1,10.2,40.889l4.057-1.307a8.222,8.222,0,0,0,15.986,0L34.3,40.889a7.878,7.878,0,0,1,5.323,6.018l.8,4.181a1.072,1.072,0,1,0,2.106-.4l-.8-4.182a10.023,10.023,0,0,0-3.091-5.521c.088-.032.176-.065.265-.093l4.059-1.308a8.224,8.224,0,0,0,15.993,0l4.059,1.308a7.88,7.88,0,0,1,5.324,6.02l2.746,14.332a1.073,1.073,0,0,0,2.107-.4L70.445,46.507a10.025,10.025,0,0,0-6.78-7.659l-7.673-2.475v-3a11.972,11.972,0,0,0,3.161-2.3,11.694,11.694,0,0,0,3.267-6.368Zm-.514-11.364v3.6h-.062l-.714-.563a.627.627,0,0,1-.242-.5V13.646a5.634,5.634,0,0,0,1.018-.305m.64,9.218V19.088a1.737,1.737,0,0,1,0,3.472M40,9.486a5.272,5.272,0,0,1,4.76-5.261,65.589,65.589,0,0,1,10.648-.081,25.558,25.558,0,0,0,7.41-.41.342.342,0,0,1,.293.066.355.355,0,0,1,.138.284V8.168a3.441,3.441,0,0,1-3.439,3.438H50.2a1.073,1.073,0,0,0,0,2.145h8.545v2.126A2.765,2.765,0,0,0,59.8,18.061l.6.471v4.574a9.448,9.448,0,0,1-18.9,0V18.532l.6-.471a2.771,2.771,0,0,0,1.06-2.183V13.751h1.975a1.073,1.073,0,1,0,0-2.145H40.56A.559.559,0,0,1,40,11.05ZM33.708,24.708a4.655,4.655,0,0,0,.936-.1v7.164a2.115,2.115,0,0,1-2.113,2.116h-5.25v-.519a12,12,0,0,0,3.164-2.3,11.692,11.692,0,0,0,3.262-6.365Zm1.816-3.983v.2a1.736,1.736,0,0,1-1.691,1.639V19.094a1.737,1.737,0,0,1,1.691,1.635Zm2.148,0a1.739,1.739,0,0,1,1.692-1.641v3.472a1.739,1.739,0,0,1-1.692-1.637v-.194Zm3.346-4.848a.633.633,0,0,1-.242.5l-.715.563H40V13.692a2.661,2.661,0,0,0,.556.059h.461ZM16.961,20.012c0,.034,0,.068,0,.1v.821a1.073,1.073,0,0,0,2.145,0v-.821a1.07,1.07,0,0,0-.38-.819A9.281,9.281,0,0,0,23.64,11.11v-1.9a9.469,9.469,0,0,1,8.048,9.338v4.569a9.622,9.622,0,0,1-9.443,9.308A9.623,9.623,0,0,1,12.8,23.114v-2.73h1.564a9.224,9.224,0,0,0,2.595-.374Zm-6.747.375h.445v2.18a1.737,1.737,0,0,1-1.595-2.325,4.766,4.766,0,0,0,1.15.142Zm.569,4.327a11.684,11.684,0,0,0,3.265,6.366,11.979,11.979,0,0,0,3.16,2.3v.517H11.953A2.114,2.114,0,0,1,9.84,31.781V24.614a4.67,4.67,0,0,0,.944.1ZM22.246,43.738A6.1,6.1,0,0,1,16.3,38.924l.9-.292v.2a1.073,1.073,0,0,0,2.145,0V34.189a11.192,11.192,0,0,0,5.785,0v4.642a1.072,1.072,0,1,0,2.144,0v-.2l.9.292a6.1,6.1,0,0,1-5.94,4.811ZM39.493,24.708a11.683,11.683,0,0,0,3.265,6.368,11.993,11.993,0,0,0,3.159,2.292v3l-7.673,2.475a10.013,10.013,0,0,0-1.641.7,10.029,10.029,0,0,0-1.651-.7l-7.67-2.474v-.335h5.25a4.261,4.261,0,0,0,4.256-4.257V23.689a4.089,4.089,0,0,0,2.7,1.017ZM50.959,43.74a6.106,6.106,0,0,1-5.95-4.823l.907-.292v.2a1.072,1.072,0,1,0,2.144,0V34.185a11.205,11.205,0,0,0,5.789,0v4.643a1.072,1.072,0,0,0,2.144,0v-.2l.907.291a6.107,6.107,0,0,1-5.945,4.817Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44557",
    "data-name": "Path 44557",
    d: "M52.689,23.038v.821a1.072,1.072,0,0,0,2.144,0v-.821a1.072,1.072,0,0,0-2.144,0",
    transform: "translate(-7.023 -2.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44558",
    "data-name": "Path 44558",
    d: "M63.492,24.933a1.072,1.072,0,0,0,1.072-1.072v-.821a1.072,1.072,0,0,0-2.144-.007v.828a1.072,1.072,0,0,0,1.072,1.072",
    transform: "translate(-8.32 -2.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44559",
    "data-name": "Path 44559",
    d: "M49.835,64.059a1.072,1.072,0,0,0-2.106.4l.995,5.194a1.072,1.072,0,1,0,2.106-.4Z",
    transform: "translate(-6.359 -8.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44560",
    "data-name": "Path 44560",
    d: "M30.369,24.934a1.072,1.072,0,0,0,1.072-1.072v-.817a1.072,1.072,0,1,0-2.144,0v.82a1.072,1.072,0,0,0,1.072,1.07",
    transform: "translate(-3.905 -2.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44561",
    "data-name": "Path 44561",
    d: "M28.138,55.386a6.95,6.95,0,0,0-4.191,1.39A7.008,7.008,0,0,0,14.8,67.343l1.829,1.829a1.073,1.073,0,0,0,1.517-1.517l-1.829-1.828a4.862,4.862,0,0,1,6.876-6.876,1.072,1.072,0,0,0,1.515,0,4.862,4.862,0,0,1,6.876,6.876l-1.828,1.829A1.072,1.072,0,1,0,31.242,69.2l.027-.027,1.83-1.83a7.007,7.007,0,0,0-4.96-11.956Z",
    transform: "translate(-1.7 -7.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44562",
    "data-name": "Path 44562",
    d: "M64.988,55.261a3.188,3.188,0,0,0-3.749,5.068l2.7,2.7a1.479,1.479,0,0,0,2.091,0l2.7-2.7a3.188,3.188,0,0,0-3.749-5.067Zm2.234,3.552-2.234,2.234-2.232-2.233a1.043,1.043,0,0,1,1.475-1.475,1.071,1.071,0,0,0,1.514,0,1.043,1.043,0,0,1,1.476,1.474",
    transform: "translate(-8.039 -7.316)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVIcon);
export default __webpack_public_path__ + "static/media/v_icon.b66ba83905c9997e32a4c12979e89f7c.svg";
export { ForwardRef as ReactComponent };